import "react-datepicker/dist/react-datepicker.css";


import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableProductTransation from "../../ui/DataTableProductTransation";
import withLoader from "../../components/layouts/WithLoader";
import SellingService from "../../services/SellingService";
import { TextField } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import toastr from "toastr";
const ProductsTransactionDepot = ({ startLoading, stopLoading }) => {
  const [warehouseManagers, setWarehouseManagers] = useState([]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const [ca, setCa] = useState(0);
  const [achat, setAchat] = useState(0);
  const [startDate, setStartDate] = useState("any");
  const [endDate, setEndDate] = useState("any");
  const id = localStorage.getItem('idProduct'); // Retrieves the 'id' value from the query string
  const idWarehouse = localStorage.getItem('idWarehouse');
  const navigate = useNavigate();

  const goToTransactionProducts = () => {
    navigate(`/TransactionProducts`);
  };
  const onChangeStartDate = (event) => {
    setStartDate(event.target.value.concat(":59"));
  };
  const onChangeEndDate = (event) => {
    setEndDate(event.target.value.concat(":59"));
  };


  const fetchProductInitialTransactions = async () => {
    try {
      startLoading();
      const response = await SellingService.getProductsTransactionsAndTransfertsByWarehouse(
        getCurrentUserId(),
        id,
        idWarehouse
      );

      console.log("response-------------->", response);
      setAvailableProducts(response.data.success);
      setProductInfo(response.data.product);
    } catch (e) {
      console.error("error", e);
    } finally {
      stopLoading();
    }
  };
  const fetchProductTransactions = async () => {
    try {
      if (startDate === "any" || endDate === "any") {
        toastr.info('La sélection de la date de début et de la date de fin est requise.');
        return null
      }
      startLoading();
      const response = await SellingService.getProductsTransactionsAndTransfertsByWarehouseAndDate(
        getCurrentUserId(),
        id,
        idWarehouse,
        startDate,
        endDate
      );

      console.log("response-------------->", response);
      setAvailableProducts(response.data.success);
      setProductInfo(response.data.product);
    } catch (e) {
      console.error("error", e);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    fetchProductInitialTransactions()
  }, []);
  const onEditWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference,
    oldWarehouseManagerId
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      name: oldWarehouseName,
      description: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
      warehouseManagerId: oldWarehouseManagerId,
    };
    setOldWarehouseData(oldWarehouseData);
    setOnEditWarehouse(true);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          {sessionStorage.getItem("typeDocument") === "Warehouse" && (
            <>
              <div className="row">
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produit</span>
                      <span className="info-box-number">
                        {productInfo?.name}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i className="fas fa-barcode"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Code-barres</span>
                      <span className="info-box-number">
                        {productInfo?.barcode}
                      </span>
                    </div>
                  </div>
                </div>

              </div>


            </>
          )}


          <section className="content ">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  {" "}
                  <button
                    type="submit"
                    onClick={goToTransactionProducts}
                    className="btn btn-dark float-right my-2"
                  >
                    Voir toutes les transactions
                  </button>
                </div>
                <div className="col-sm-12">
                  <div class="card">
                    <div className="card-header">
                      <h3 className="card-title">Filtrer par date</h3>
                    </div>
                    <div class="card-body">
                      <div className="form-group col-12 col-sm-12 row ">
                        <div className="col-sm-6 ">
                          <label>Choisir la date de début</label>
                          <TextField
                            style={{ width: "100%" }}
                            className="col-sm-12"
                            variant="outlined"
                            value={startDate}
                            onChange={onChangeStartDate}
                            id="datetime-local"
                            type="datetime-local"
                            defaultValue="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                          />

                        </div>
                        <div div className="col-sm-6 ">
                          <label>Choisir la date de fin</label>
                          <TextField
                            style={{ width: "100%" }}
                            className="col-sm-12"
                            variant="outlined"
                            value={endDate}
                            onChange={onChangeEndDate}
                            id="datetime-local"
                            type="datetime-local"
                            defaultValue="date"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card-footer">
                      <button
                        type="submit"
                        onClick={fetchProductTransactions}
                        className="btn btn-dark float-right"
                      >
                        Valider
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="row ">
            <div className="col-sm-12">
              {availableProducts && (
                <DataTableProductTransation listProduits={availableProducts} />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(ProductsTransactionDepot);
